import { toJS } from 'mobx';

// Returns Booleen
export function tabIsOpen(tabs: any, baseUrl: any) {
  return toJS(tabs).openTabs.some((item: any) => item.url.includes(baseUrl));
}

// Returns Tab
export function getOpenTab(tabs: any, baseUrl: any) {
  return toJS(tabs).openTabs.find((tab: any) => {
    return tab.url.includes(baseUrl);
  });
}
